import { parser } from "./parser";
import { LezerSyntax } from "@reactivepad/codemirror-next/syntax";

export var formulaSyntax = new LezerSyntax(parser.withProps());

export function formula() {
  return formulaSyntax.extension;
}